import { atomWithReset } from 'jotai/utils';

import { SettingsDrawer } from './types';

export const settingsDrawerState = atomWithReset<SettingsDrawer>({
  drawer: null,
});
